import { AccountState } from '@exodus/models'

import { parseLegacyBalances } from './parse-legacy-balances.js'

// `assets` are only needed for chains that may need legacy parsing and staking support
export default function createEthereumLikeAccountState({ asset, extraData = {}, assets = {} }) {
  return class EthereumLikeAccountState extends AccountState {
    static defaults = {
      startblock: 0, // deprecated. It seems not used anymore. Remove when it's safe
      clarityCursor: '',
      balance: asset.currency.ZERO,
      tokenBalances: {},
      index: 0,
      ...extraData,
    }

    // legacy -- this should have no effect on Ethereum-like assets that do not have legacy account state
    static _tokens = Object.values(assets)
    static _postParse(data) {
      return { ...data, tokenBalances: parseLegacyBalances(data.tokenBalances, assets) }
    }
  }
}
